<div class="accounting-basis-container">
  <div class="accounting-basis-panel">
    <!-- <nz-collapse [nzBordered]="false"> -->
    <!-- <nz-collapse-panel -->
    <!-- [nzHeader]="accountingBasisHeaderTemplate" -->
    <!-- [nzShowArrow]="false" -->
    <!-- > -->
    <nz-radio-group
      [(ngModel)]="tempModel.selected"
      [nzSize]="'small'"
      (ngModelChange)="onValueChange()"
    >
      <label
        nz-radio
        nzValue="All"
        nzSize="small"
        nz-popover
        [nzPopoverContent]="allContentTemplate"
        nzType="primary"
        nzPopoverPlacement="left"
        >All</label
      >
      <label
        nz-radio
        nzValue="Operating"
        nzSize="small"
        nz-popover
        [nzPopoverContent]="operatingContentTemplate"
        nzPopoverPlacement="left"
        >Operating</label
      >
      <label
        nz-radio
        nzValue="GAAP"
        nzSize="small"
        nz-popover
        [nzPopoverContent]="GAAPContentTemplate"
        nzPopoverPlacement="left"
        >GAAP</label
      >
    </nz-radio-group>

    <div class="action-buttons">
      <button
        [disabled]="disabled"
        nz-button
        nzType="default"
        nzSize="small"
        [ngClass]="!disabled ? 'cancelBtn' : ''"
        (click)="onCancelClick()"
      >
        Cancel
      </button>

      <button
        id="options-refresh-buttons-apply-Accounting_basis"
        [disabled]="disabled"
        nz-button
        nzType="primary"
        nzSize="small"
        (click)="onApplyClick($event)"
      >
        Apply
      </button>
    </div>
    <!-- </nz-collapse-panel> -->
    <!-- </nz-collapse> -->
  </div>


  <ng-template #allContentTemplate>
    <div class="accounting-basis-popover">
      <span
        >Select this option to display all available accounts regardless of
        accounting basis.</span
      >
    </div>
  </ng-template>

  <ng-template #operatingContentTemplate>
    <div class="accounting-basis-popover">
      <span
        >Select this view to display the financial statements on an operating
        basis which typically excludes stock based compensation, non-operating
        items and non-recurring/one-time items.</span
      >
    </div>
  </ng-template>

  <ng-template #GAAPContentTemplate>
    <div class="accounting-basis-popover">
      <span
        >Select this view to display the financial statements on a GAAP
        basis.</span
      >
    </div>
  </ng-template>
</div>
